module.exports = __webpack_public_path__ + "assets/c69d765c2a2efae957a993ae8097c061.mp3";